import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';

import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { SafeUrlPipe } from '../../pipes/safe-url.pipe';

import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { OccasionGeniusEvent } from 'src/app/core/types/models/occasion-genius-event.model';

import { OccasionGeniusWithFiltersComponent } from '../../components/occasion-genius-map/occasion-genius-map.component';

import moment from 'moment';

@Component({
  selector: 'app-occasion-genius-details-dialog',
  imports: [
    MatOption,
    MatIcon,
    CdkCopyToClipboard,
    OccasionGeniusWithFiltersComponent,
    MatSelectModule,
    TranslateModule,
    FormsModule,
    SafeUrlPipe,
    NgTemplateOutlet,
  ],
  templateUrl: './occasion-genius-details-dialog.component.html',
  styleUrl: './occasion-genius-details-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OccasionGeniusDetailsDialogComponent {
  protected readonly eSvgIcons = ESvgIcons;
  protected selectedEvent: OccasionGeniusEvent;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      events: OccasionGeniusEvent[];
      countryName: string;
      cityName: string;
    },
    protected readonly dialogRef: MatDialogRef<OccasionGeniusDetailsDialogComponent>,
    private readonly googleAnalyticService: GoogleAnalyticService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private authService: AuthService,
    protected breakpointService: BreakpointService,
  ) {
    this.selectedEvent = this.data.events[0];
  }

  get isOneEvent(): boolean {
    return this?.data?.events?.length === 1;
  }

  protected copiedToClipboardHandler(): void {
    const translation = this.translateService.instant('OCCASION_GENIUS.COPIED');
    this.toastService.showSuccessSnack(translation);
  }

  protected formattedEventDate(startDate: string, endDate: string): string {
    const start = moment(startDate).format('dddd, MMMM D, h:mm A');
    const end = moment(endDate).format('h:mm A');
    return `${start} - ${end}`;
  }

  protected setGoogleAnalytic() {
    this.googleAnalyticService.setOccasionGeniusAnalytic({
      activityName: this.selectedEvent.name,
      countryName: this.data.countryName,
      cityName: this.data.cityName,
      userID: this.authService.userId,
    });
  }
}
